module.exports = __webpack_public_path__ + "img/parallax3-1024p.a2fd3ff0.jpg";